
export default function BioSection() {
  return (
    <section id="bio" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold border-l-4 border-teal-500 pl-4 mb-10">
          Unprecedented Authority: Policy & Practice
        </h2>
        <div className="grid md:grid-cols-3 gap-10 text-lg">
          
          <div className="space-y-4 p-6 bg-gray-50 rounded-xl shadow-md border-t-4 border-teal-500">
            <h3 className="text-xl font-bold text-gray-900">Federal Service & Technology Leadership</h3>
            <p className="text-gray-700">
              Currently serving as <strong>Contract Analyst at SLAC National Accelerator Laboratory, Research Center at Stanford University</strong>, Alberto brings four decades of federal expertise. As a former 18-year <strong>Contracting Officer's Technical Representative with the U.S. Department of the Navy</strong> (managing $100M+ in procurement) and <strong>Senior Executive Management Development Program (SEMDP) selectee</strong>, he delivers unparalleled regulatory compliance and systemic accountability expertise.
            </p>
            <p className="text-sm font-semibold text-teal-600">
              The foundation: Decades of managing complex federal systems and massive-scale procurement.
            </p>
          </div>

          <div className="space-y-4 p-6 bg-gray-50 rounded-xl shadow-md border-t-4 border-teal-500">
            <h3 className="text-xl font-bold text-gray-900">Civil Rights Pioneer</h3>
            <p className="text-gray-700">
              Eight years working under civil rights legend <strong>Angel Luevano at the U.S. Department of Labor, Office of Federal Contract Compliance</strong>, enforcing the landmark <strong>Luevano Consent Decree</strong>, shaped his understanding of building fairness into complex systems—lessons now applied to artificial intelligence governance and ethical AI implementation.
            </p>
            <p className="text-sm font-semibold text-teal-600">
              The insight: Civil rights principles become AI ethics frameworks.
            </p>
          </div>

          <div className="space-y-4 p-6 bg-gray-50 rounded-xl shadow-md border-t-4 border-teal-500">
            <h3 className="text-xl font-bold text-gray-900">Strategic Leadership & Community Impact</h3>
            <p className="text-gray-700">
              As former <strong>President & CEO of National Image, Inc.</strong>, built strategic partnerships with the Department of Defense. Co-founder of the <strong>Leadership Institute for Diversity</strong> and former <strong>Executive Director of the Hispanic Chamber of Commerce for Alameda County</strong>, dedicated to expanding opportunity and representation across sectors.
            </p>
            <p className="text-sm font-semibold text-teal-600">
              The mission: A lifetime expanding access and building bridges.
            </p>
          </div>

        </div>

        {/* Additional Bio Content */}
        <div className="mt-16 grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900">From Civil Rights to AI Ethics</h3>
            <p className="text-lg text-gray-700">
              <strong>Alberto S. Rocha, Technology Ethicist | AI Governance Strategist</strong> is a humanitarian leader and AI ethics practitioner bridging four decades of federal service with cutting-edge technology governance. His journey from enforcing civil rights compliance to pioneering AI accountability frameworks represents a unique convergence of regulatory expertise and ethical innovation.
            </p>
            <p className="text-lg text-gray-700">
              Author of <strong>19 books on AI</strong> and host of the 200-episode podcast <strong>"AI and Us: Exploring Our Future,"</strong> Rocha's forthcoming book <strong>"AI is More Human than Humans: A Mirror to Our Better Angels"</strong> offers the first practitioner's guide to implementing <strong>NIST AI RMF Executive Order mandates</strong> through <strong>Consistency Auditing</strong>—a methodology making ethical AI governance actionable for the 430+ federal agencies required to comply.
            </p>
            <p className="text-lg text-gray-700">
              A <strong>Congressional appointee</strong>, professional speaker with <strong>40 years of experience</strong>, and passionate advocate for algorithmic accountability, Rocha connects the civil rights movement's lessons to today's AI challenges. At 70, he brings the perspective of someone who has spent a lifetime mastering the fundamentals—and now teaches others to do the same.
            </p>
            <div className="flex space-x-4 pt-4">
              <div className="text-center">
                <div className="text-3xl font-bold text-teal-600">40+</div>
                <div className="text-sm text-gray-600">Years Federal Service</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-teal-600">19</div>
                <div className="text-sm text-gray-600">Books on AI</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-teal-600">200+</div>
                <div className="text-sm text-gray-600">Podcast Episodes</div>
              </div>
            </div>
          </div>
          <div className="flex justify-center">
            <img 
              src="https://static.readdy.ai/image/d284d72deac738ef2474c9b45b1f2d97/e55fecbc051de469039fff7949d45eca.png"
              alt="Alberto Rocha - Author and Speaker" 
              className="rounded-xl shadow-lg max-w-sm object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
